import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as WarningImage } from "../../assets/warning.svg";

const ErrorDialog = ({ open, onClose, errorMessage }: any) => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: `${colors.modal.background} !important`,
          color: `${colors.modal.title} !important`,
          width: "medium",
          borderRadius: "8px",
        },
      }}
    >
      {/* Header Section */}
      <DialogTitle
        sx={{
          backgroundColor: `${colors.modal.titleBg} !important`,
          color: `${colors.modal.title} !important`,
          p: 1,
          pl: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: `${colors.modal.title} !important`,
            fontWeight: 600
          }}
        >
          Error in Saving Alert
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            color: `${colors.modal.title} !important`,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content Section */}
      <DialogContent
        sx={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: `${colors.modal.background} !important`
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
        >
          <WarningImage
            style={{
              width: 40,
              height: 40,
              padding: 8
            }}
          />

          <Box textAlign="left" flex={1}>
            <Typography
              variant="bodyLabel"
              sx={{
                marginTop: "10px",
                fontWeight: 500,
                color: `${colors.modal.text} !important`
              }}
            >
              There was an error while saving the alert. Address the issue and try again.
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 0.5,
                color: `${colors.modal.text} !important`
              }}
            >
              {errorMessage}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      {/* Actions Section */}
      <DialogActions
        sx={{
          justifyContent: "flex-end",
          padding: "20px",
          backgroundColor: `${colors.modal.background} !important`
        }}
      >
        <Button
          onClick={onClose}
          variant="pepwiseButtonText"
          sx={{
            color: `${colors.buttons.primary.borderedText} !important`,
            fontWeight: 600,
            textTransform: "uppercase",
            backgroundColor: "transparent !important",

            "&:hover": {
              color: `${colors.buttons.primary.borderedHoverText} !important`,
              backgroundColor: "transparent !important"
            }
          }}
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;